module.exports = __webpack_public_path__ + "media/timelapse-art.eea4d27b.mp4";